import React, { useCallback, useEffect, useState } from "react";
import "./App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useNavigate,
  useLocation,
} from "react-router-dom";

import CursorTrail from "./components/CursorTrail";
import Home from "./pages/Home";
import WorksIntro from "./pages/WorksIntro";
import WorksGallery from "./pages/WorksGallery";
import WorkDetail from "./pages/WorkDetail";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminHome from "./pages/admin/AdminHome";
import AdminEdit from "./pages/admin/AdminEdit";
import AdminRevisions from "./pages/admin/AdminRevisions";
import AdminGuide from "./pages/admin/AdminGuide";
import AdminGuard from "./pages/admin/AdminGuard";
import { ContentProvider } from "./content/ContentProvider";

// ---- Route fade context ----
export const RouteFadeContext = React.createContext({
  fadeTo: () => {},
});

function FadeShell({ children }) {
  const [black, setBlack] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  // when route changes, ensure overlay clears (fade-in of new page)
  useEffect(() => {
    setBlack(false);
  }, [location.pathname]);

  const fadeTo = useCallback(
    (path, delay = 700) => {
      setBlack(true);
      window.setTimeout(() => {
        navigate(path);
      }, delay);
    },
    [navigate]
  );

  return (
    <RouteFadeContext.Provider value={{ fadeTo }}>
      {children}
      <div
        className="route-fade"
        style={{ opacity: black ? 1 : 0 }}
        aria-hidden="true"
      />
    </RouteFadeContext.Provider>
  );
}

function App() {
  return (
    <div className="App">
      <ContentProvider>
        <BrowserRouter>
          <FadeShell>
            <CursorTrail />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/works" element={<WorksIntro />} />
              <Route path="/works/deeper" element={<WorksGallery />} />
              <Route path="/works/deeper/:slug" element={<WorkDetail />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <AdminGuard>
                    <AdminHome />
                  </AdminGuard>
                }
              />
              <Route
                path="/admin/edit"
                element={
                  <AdminGuard>
                    <AdminEdit />
                  </AdminGuard>
                }
              />
              <Route
                path="/admin/revisions"
                element={
                  <AdminGuard>
                    <AdminRevisions />
                  </AdminGuard>
                }
              />
              <Route
                path="/admin/guide"
                element={
                  <AdminGuard>
                    <AdminGuide />
                  </AdminGuard>
                }
              />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </FadeShell>
        </BrowserRouter>
      </ContentProvider>
    </div>
  );
}

export default App;
